import { Component, Inject, OnDestroy, HostBinding, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
  IModalsService,
  IMODALS_SERVICE,
  INotificationsService,
  INOTIFICATIONS_SERVICE,
  P500UIBaseModal,
  NumberFieldComponent,
} from '@platform500services/p500-ui-kit';
import { IUnsecuredService } from '../../services/unsecured/unsecured-service.interface';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './2fa.modal.html',
})
export class Auth2FAModal extends P500UIBaseModal implements OnInit, OnDestroy {
  constructor(
    @Inject(IMODALS_SERVICE) public modalsService: IModalsService,
    @Inject('IUnsecuredService') public unsecuredService: IUnsecuredService,
    @Inject(INOTIFICATIONS_SERVICE) private notificationsService: INotificationsService,
    public router: Router,
    public cd: ChangeDetectorRef
  ) {
    super(modalsService, router);
  }

  @HostBinding('class') get className() {
    return `c-modal c-modal--d c-modal--action-form c-modal--2fa -primary -xsmall`;
  }
  @ViewChild(NumberFieldComponent) private otpField!: NumberFieldComponent;
  public isLoading = true;
  public placeholder = $localize`:@@common.enter_code:Enter code...`;
  public tokenControl = new UntypedFormControl(null, Validators.required);

  @Input() public callback = (): void => {};

  ngOnInit(): void {
    this.unsecuredService
      .enable()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cd.detectChanges();
          this.otpField.focusInput();
        })
      )
      .subscribe(() => {
        this.notificationsService.add(
          { type: 'success', title: $localize`:@@common.2fa_code_success_send:The 2FA code has been sent` },
          true
        );
      });

    this.subscribers.tokenValue = this.tokenControl.valueChanges.subscribe((value: number | null) => {
      if (value?.toString()?.length === 6 && this.tokenControl.valid && !this.isLoading) {
        this.submit();
      }
    });
  }

  resendCode(): void {
    this.unsecuredService.enable().subscribe(() => {
      this.notificationsService.add(
        { type: 'success', title: $localize`:@@common.2fa_code_success_send:The 2FA code has been sent` },
        true
      );
    });
  }

  submit(): void {
    this.isLoading = true;
    this.unsecuredService
      .enable(this.tokenControl.value)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response) => {
        if (response.data?.user) {
          this.unsecuredService.setUnsecuredStatus(true);
          this.modalsService.closeAll();
          this.callback();
        }
      });
  }
}
